import type { LucideIcon } from "lucide-react";
import {
  Accessibility,
  Baby,
  BookOpen,
  Leaf,
  ShieldAlert,
  Sprout,
  Stethoscope,
  Users,
  UtensilsCrossed,
  Wallet,
} from "lucide-react";

export type DonationCategoryDef = {
  value: string;
  label: string;
  icon: LucideIcon;
};

export const DONATION_CATEGORIES: DonationCategoryDef[] = [
  { value: "healthcare", label: "Healthcare", icon: Stethoscope },
  { value: "education", label: "Education", icon: BookOpen },
  { value: "nutrition", label: "Nutrition", icon: UtensilsCrossed },
  { value: "general", label: "General Fund", icon: Wallet },
  { value: "emergency", label: "Emergency Relief", icon: ShieldAlert },
  { value: "women", label: "Women Empowerment", icon: Users },
  { value: "child", label: "Child Welfare", icon: Baby },
  { value: "disability", label: "Disability Support", icon: Accessibility },
  { value: "environment", label: "Environment", icon: Leaf },
  { value: "livelihood", label: "Livelihood", icon: Sprout },
];

export type DonationCategory = (typeof DONATION_CATEGORIES)[number]["value"];

export function getCategoryLabel(value: string): string {
  return (
    DONATION_CATEGORIES.find((c) => c.value === value)?.label ?? value
  );
}

export function getCategoryIcon(value: string): LucideIcon {
  return (
    DONATION_CATEGORIES.find((c) => c.value === value)?.icon ?? Wallet
  );
}
